const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const WonkyButton = require("./WonkyButton");
const AssetsUtil = require("../util/AssetsUtil");

const styles = require("./styles/ModalGeneral.css");

module.exports = createReactClass({
	displayName: "ChooseOptionModal",

	propTypes: {
		styleType: PT.string,
		size: PT.string,
		onClose: PT.func,
		levelType: PT.string,
		buttons: PT.arrayOf(PT.oneOfType([PT.element, PT.object])),
		modalClass: PT.string,
		buttonsContainerClass: PT.string,
		portalContainer: PT.string,
		cannotClose: PT.bool,
	},

	render: function() {
		const {
			portalContainer = PORTAL_CONTAINERS.TRAINER_MESSAGE,
			onClose,
			levelType = "default",
			styleType = "default",
			cannotClose = false,
			children,
			size,
			buttons,
			buttonsContainerClass,
		} = this.props;

		let modalClass = styles.message + " " + styles[styleType];
		if (this.props.modalClass) modalClass += " " + this.props.modalClass;

		const bgEl = (
			<img className={styles.bg} src={AssetsUtil.getConfirmModal(styleType)} />
		);
		if (size) {
			modalClass += " " + styles[size];
		}

		const renderedButtons = buttons.map((button, i) => {
			return React.isValidElement(button) ? (
				button
			) : (
				<WonkyButton
					key={"button-" + i}
					className={styles.button}
					handleClick={button.handleClick}
					buttonType={button.buttonType}
					buttonText={button.buttonText}
					variant={button.variant}
					linkTo={button.linkTo}
					onLinkClick={button.onLinkClick}
				/>
			);
		});
		return (
			<div>
				<Modal
					portalContainer={portalContainer}
					onClose={onClose}
					closeOnBackdropClick={!cannotClose}
					closeOnEsc={!cannotClose}
					hasCloseButton={!cannotClose}
					backdropClass={styles.backdrop}
					modalClass={modalClass}
					levelType={levelType}
				>
					{bgEl}
					{children}
					<div className={buttonsContainerClass ?? styles.buttons}>
						{renderedButtons}
					</div>
				</Modal>
			</div>
		);
	},
});
